<template>
  <section class="hero" @mousemove="(e) => desktop && paintAnimation(e)">
    <h1 v-html="content.title" class="hero__title" />
    <h2 class="hero__subtitle">{{ content.subtitle }}</h2>
    <div class="hero__background">
      <div class="hero__background__left" id="left">
        <img
          :src="`images/${content.images.left}.png`"
          alt=""
          class="hero__background__left__img"
        />
      </div>
      <div class="hero__background__right" id="right">
        <img
          :src="`images/${content.images.right}.png`"
          alt=""
          class="hero__background__right__img"
        />
      </div>
    </div>
    <ScrollCta
      :icon="content.cta.icon"
      :label="content.cta.label"
      :id="content.cta.id"
    />
  </section>
</template>
<script setup>
import { computed, inject } from "vue";
import ScrollCta from "./DumbComponents/ScrollDown.vue";

defineProps({
  content: Object,
});

const tvaMq = inject("$tvaMq");
const desktop = computed(() => tvaMq.value === "desktop");

const paintAnimation = (value) => {
  const right = document.getElementById("right");
  const left = document.getElementById("left");
  let sectionWidth = value.clientX + "px";

  if (value.clientX > window.innerWidth / 2) {
    right.style.width = sectionWidth;
  } else {
    left.style.width = window.innerWidth - value.clientX + "px";
  }
};
</script>
<style lang="scss" scoped>
.hero {
  height: calc(var(--vh, 1vh) * 100);
  width: 100vw;
  color: $scala-grigi-gray_1;
  padding-top: 20vh;
  position: relative;
  overflow: hidden;

  &__title {
    @include mega;

    :deep(.highlight) {
      @include mega-bold;
    }
  }

  &__subtitle {
    @include title-h-2;
  }

  &__background {
    position: absolute;
    top: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    display: flex;

    &__left {
      width: 50%;
      height: 100%;
      background-color: $scala-grigi-gray-6;
      position: relative;

      &__img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%);
        margin: auto;
      }
    }
    &__right {
      @extend .hero__background__left;
      background-color: $primary-yellow;

      &__img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}

.tablet,
.mobile {
  .hero {
    padding-top: 18vh;

    &__title {
      font-size: toRem(155);

      :deep(.highlight) {
        font-size: toRem(155);
      }
    }

    &__subtitle {
      font-size: toRem(41);
    }
    &__background {
      &__left {
        &__img {
          width: toRem(410);
          height: toRem(350);
          transform: none;
          left: -68px;
        }
      }
      &__right {
        &__img {
          width: toRem(430);
          height: toRem(348);
          transform: none;
          right: -111px;
          left: auto;
        }
      }
    }

    &__cta {
      bottom: toRem(41);

      &__label {
        text-transform: uppercase;
        @include link-l;
      }

      &__icon {
        height: 2.63rem;
      }
    }
  }
}

.mobile {
  .hero {
    padding-top: 15vh;

    &__title {
      font-size: toRem(90);
      line-height: toRem(96.75);

      :deep(.highlight) {
        font-size: toRem(90);
        line-height: toRem(96.75);
      }
    }

    &__subtitle {
      font-size: toRem(23);
    }

    &__background {
      &__left {
        &__img {
          width: toRem(222);
          height: toRem(190);
          left: -51px;
        }
      }

      &__right {
        &__img {
          width: toRem(235);
          height: toRem(190);
          right: -66px;
        }
      }
    }
  }
}
</style>
